import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onClearFilters }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-8 sm:p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No Jobs Found
        </h3>
        
        <p className="text-muted-foreground mb-6">
          We couldn't find any jobs matching your search criteria. Try adjusting your filters or search terms.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            variant="outline"
            onClick={onClearFilters}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Clear Filters
          </Button>
          <Button 
            variant="default"
            onClick={() => window.location.href = '/job-seeker-dashboard'}
            iconName="Home"
            iconPosition="left"
          >
            Go to Dashboard
          </Button>
        </div>

        <div className="mt-8 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground mb-3">Popular searches:</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {['Software Engineer', 'Data Analyst', 'Product Manager', 'UI/UX Designer', 'Sales Executive']?.map((term) => (
              <button
                key={term}
                className="px-3 py-1.5 bg-muted text-muted-foreground text-sm rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;